<template>
    <ul id="arbol-seleccion-intranet">
        <li><div>{{ nodoInicial[identificadoresObjeto.texto] }}</div>
            <seleccionHijo 
                v-if="nodoInicial[identificadoresObjeto.hijo] != undefined && nodoInicial[identificadoresObjeto.hijo] != null"
                :nodoPrincipal="nodoInicial[identificadoresObjeto.hijo]"
                :identificadoresObjeto="{ hijo: 'hijo', texto: 'texto' }"></seleccionHijo>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'seleccionHijo',
    props: {
        nodoPrincipal: Object,
        identificadoresObjeto: Object,
        listaAObjetoArbol: {
            type: Object,
            default: () => ({ covertir: false, lista: [] })
        }
    },
    data() {
        return {
            nodoInicial: null
        }
    },
    methods: {
        obtenerObjArbolSeleccion: function({ elementos }) {
            let arbol = null;
            const LONGITUD_HISTORIAL = elementos.length;
            if(LONGITUD_HISTORIAL > 0) {
                const PRIMER_SELECCION_OBJ = elementos[0];
                arbol = { hijo: null, texto: PRIMER_SELECCION_OBJ.Nombre };
                let anterior = null;
                for(let i = 1; i < LONGITUD_HISTORIAL; i++) {
                    let sh = elementos[i];
                    if(i == 1) {
                        arbol.hijo = { hijo: null, texto: sh.Nombre };
                        anterior = arbol.hijo;
                    }
                    else {
                        anterior.hijo = { hijo: null, texto: sh.Nombre };
                        anterior = anterior.hijo;
                    }
                }
            }
            console.log('arbol::',arbol);
            return arbol;
        },
    },
    created() {
        if(this.listaAObjetoArbol.covertir)
            this.nodoInicial = this.obtenerObjArbolSeleccion({ elementos: this.listaAObjetoArbol.lista });
        else
            this.nodoInicial = this.nodoPrincipal;
    },
    watch: {
        'listaAObjetoArbol.lista': function() {
            if(this.listaAObjetoArbol.covertir)
            this.nodoInicial = this.obtenerObjArbolSeleccion({ elementos: this.listaAObjetoArbol.lista });
        }
    }
}
</script>
<style scoped>
#arbol-seleccion-intranet ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: relative;
}

#arbol-seleccion-intranet li {
  list-style-type: none;
  margin-left: 1em;
}

#arbol-seleccion-intranet li div {
  padding-left: 1em;
  position: relative;
}

#arbol-seleccion-intranet li div::before {
  content:'';
  position: absolute;
  top: 0;
  left: -2px;
  bottom: 50%;
  width: 0.75em;
  border: 2px solid #000;
  border-top: 0 none transparent;
  border-right: 0 none transparent;
}

#arbol-seleccion-intranet ul > li:last-child {
  border-left: 2px solid transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Intranet/Contenidos/CArbolDeSeleccion.vue